// ===========================================================================
// CostHeroBlock — bloque protagonista del análisis: el gasto total domina,
// con satélites pequeños (costo promedio, nuevos/reaparecidos).
// ===========================================================================
import React from "react";
import { Box, Paper, Typography, Stack, Skeleton } from "@mui/material";
import { formatCompactCurrency, formatCurrency, formatPercent } from "../../utils/format";

const Satellite = ({ label, value }) => (
  <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2, minWidth: 150 }}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h6" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Paper>
);

export default function CostHeroBlock({ kpis, loading }) {
  if (loading) {
    return <Skeleton variant="rounded" height={160} sx={{ borderRadius: 3 }} />;
  }

  if (!kpis) {
    return (
      <Paper variant="outlined" sx={{ p: 3, borderRadius: 3 }}>
        <Typography variant="body2" color="text.secondary">
          KPIs not available yet.
        </Typography>
      </Paper>
    );
  }

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="stretch">
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          flex: 2,
          background: "linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)",
          color: "#fff",
        }}
      >
        <Typography variant="overline" sx={{ opacity: 0.85 }}>
          Total population cost
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 900, lineHeight: 1.1, fontVariantNumeric: "tabular-nums" }}>
          {formatCompactCurrency(kpis.totalCost)}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9, mt: 1 }}>
          {Number(kpis.patients || 0).toLocaleString()} active patients ·{" "}
          {formatPercent(kpis.top10Pct)} concentrated in the top 10%
        </Typography>
      </Paper>

      <Stack spacing={2} sx={{ flex: 1, justifyContent: "center" }}>
        <Satellite label="Avg cost / patient" value={formatCurrency(kpis.avgCost)} />
        <Satellite
          label="New this week"
          value={`+${kpis.newThisWeek ?? 0} (${kpis.presentReturning ?? 0} returning)`}
        />
      </Stack>
    </Stack>
  );
}
